import React, { useState } from "react";
import ModalCenter from "../../../../components/common/Modal/ModalCenter";
import Button from "../../../../components/common/buttons/Button";
import InputTextSimple from "../../../../components/common/InputText/InputTextSimple";
import CheckBoxWithOutLabel from "../../../../components/common/checkbox/CheckboxWithoutLabel";
import ButtonFluid from "../../../../components/common/buttons/ButtonFluid";
import ButtonOutlineFluid from "../../../../components/common/buttons/ButtonOutlineFluid";
import InputNumbersSimple from "../../../../components/common/InputText/InputNumbersSimple";
import InputNumbersSimpleDefault from "../../../../components/common/InputText/InputNumbersSimpleDefault";
import HttpHelper from "../../../../helpers/Http/HttpHelper";
import { API_ROUTES } from "../../../../constants/API_ROUTES";
import useAuth from "../../../../hooks/useAuth";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../../../constants/Routes";
import { useDispatch } from "react-redux";
import { ProposalItemActions } from "../../../../store/Slice/ProposalItemSlice";
const PackingMaterialCreateModal = ({ saveItems }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [verpackungsmaterial, setVerpackungsmaterial] = useState("");
  const [verpackungsmaterialError, setVerpackungsmaterialError] = useState("");
  const [ar, setAr] = useState("");
  const [arError, setArError] = useState("");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { clearAuth, getAuth } = useAuth();
  const openModal = () => {
    setIsOpen(true);
  };

  const closeModal = () => {
    setIsOpen(false);
  };

  const clearErrors = () => {
    setArError("");
    setVerpackungsmaterialError("");
  };

  const resetForm = () => {
    setAr("");
    setVerpackungsmaterial("");
    setArError("");
    setVerpackungsmaterialError("");
  };

  const pushNewPackingMaterial = (data) => {
    dispatch(ProposalItemActions.pushNewPackingMaterial(data?.packingMaterial));
  };

  const createPackingMaterial = () => {
    clearErrors();
    HttpHelper.PostRequest({
      route: API_ROUTES.PACKING_MATERIAL_CREATE,
      token: getAuth()?.bearerToken,
      parameters: {
        verpackungsmaterial,
        ar,
      },
    })
      .then((res) => {
        if (res?.status === 200) {
          resetForm();
          pushNewPackingMaterial(res?.data);
          closeModal();
          toast.success(res?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 422) {
          const messages = res.message;
          for (const key in messages) {
            if (messages.hasOwnProperty(key) && Array.isArray(messages[key]) && messages[key].length > 0) {
              const errorMessage = messages[key][0];
              if (key === "verpackungsmaterial") {
                setVerpackungsmaterialError(errorMessage);
              } else if (key === "ar") {
                setArError(errorMessage);
              }
            }
          }
        } else if (res.status === 500) {
          toast.error(res?.message, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        } else if (res.status === 401) {
          clearAuth();
          navigate(ROUTES.AUTH);
        } else {
          toast.error("Hiba, a kezdőhely nem lett létrehozva.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          });
        }
      })
      .catch((error) => {
        toast.error("Hiba, a kezdőhely nem lett létrehozva.", {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "light",
        });
      });
  };

  return (
    <>
      <div className="flex gap-4">
        <ButtonOutlineFluid onClick={openModal} label={`Új Verpackungsmaterial`} />
        <ButtonFluid label={`Mentés`} onClick={saveItems} />
      </div>

      <ModalCenter isOpen={isOpen} closeModal={closeModal} header="Új Verpackungsmaterial">
        <div className="grid grid-cols-[150px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] text-[#323232] font-lato font-normal leading-normal">
            Verpackungsmaterial
          </label>
          <InputTextSimple
            placeholder={``}
            variant="light"
            id={"Verpackungsmaterial"}
            name={"Verpackungsmaterial"}
            value={verpackungsmaterial}
            onChange={(e) => setVerpackungsmaterial(e.target.value)}
            error={verpackungsmaterialError}
          />
        </div>
        <div className="grid grid-cols-[150px_1fr] items-center gap-[1.875rem] mt-[1.6rem]">
          <label className="text-[1rem] w-[12rem] text-[#323232] font-lato font-normal leading-normal">ár</label>
          <InputNumbersSimpleDefault
            id={"ar"}
            name={"ar"}
            value={ar}
            onChange={(e) => setAr(e.target.value)}
            error={arError}
            placeholder={``}
            variant="light"
          />
        </div>

        <div className="mt-12 ps-[230px] gap-5 flex flex-row  text-center">
          <ButtonFluid label={`Mentés`} onClick={createPackingMaterial} />
        </div>
      </ModalCenter>
    </>
  );
};

export default PackingMaterialCreateModal;
